import KeyValueRenderer from "./KeyValueRenderer";
import TableRenderer from "./TableRenderer";
import PostsQualificationRenderer from "./PostsQualificationRenderer";
import BulletRenderer from "./BulletRenderer";
import LinksRenderer from "./LinksRenderer";
import ParagraphRenderer from "./ParagraphRenderer";
import StepsRenderer from "./StepsRenderer";
import FAQRenderer from "./FAQRenderer";
import SalaryRenderer from "./SalaryRenderer";
import ExamPatternRenderer from "./ExamPatternRenderer";
import CategoryVacancyRenderer from "./CategoryVacancyRenderer";


export default function SectionRenderer({ section, renderValue }) {

    // Special handling
    if (section.title === "Posts & Qualifications") {
        return <PostsQualificationRenderer section={section} />;
    }
    console.log("Section:", section.title);
    console.log("Type:", section.type);

    switch (section.type) {

        case "table":

            if (section.title === "Category-wise Vacancies") {
                return <CategoryVacancyRenderer section={section} />;
            }

            return <TableRenderer section={section} />;

        case "bullet":
            return <BulletRenderer section={section} />;

        case "links":
            return <LinksRenderer section={section} />;

        case "paragraph":
            return <ParagraphRenderer section={section} />;

        case "steps":
            return <StepsRenderer section={section} />;

        case "faq":
            return <FAQRenderer section={section} />;
        case "salary_table":
            return <SalaryRenderer section={section} />;
        case "exam_pattern":
            return <ExamPatternRenderer section={section} />;

        default:
            return (
                <KeyValueRenderer
                    section={section}
                    renderValue={renderValue}
                />
            );
    }
}

// import KeyValueRenderer from "./KeyValueRenderer";
// import TableRenderer from "./TableRenderer";
// import PostsQualificationRenderer from "./PostsQualificationRenderer";
// import BulletRenderer from "./BulletRenderer";
// import LinksRenderer from "./LinksRenderer";
// import ParagraphRenderer from "./ParagraphRenderer";
// import StepsRenderer from "./StepsRenderer";
// import FAQRenderer from "./FAQRenderer";
// import SalaryRenderer from "./SalaryRenderer";
// import ExamPatternRenderer from "./ExamPatternRenderer";
// import CategoryVacancyRenderer from "./CategoryVacancyRenderer";

// export default function SectionRenderer({ title, section, renderValue }) {
//     if (!section) return null;

//     const sectionTitle = section.title || title;
//     const sectionType = section.type;

//     console.log("Section Key:", title);
//     console.log("Section Title:", sectionTitle);
//     console.log("Section Type:", sectionType);
//     console.log("Section Data:", section);

//     if (
//         title === "Exam Pattern" ||
//         sectionTitle === "Exam Pattern" ||
//         sectionType === "exam_pattern" ||
//         section?.fields?.rows
//     ) {
//         return <ExamPatternRenderer section={section} />;
//     }

//     if (
//         title === "Total Posts and Qualifications" ||
//         sectionTitle === "Posts & Qualifications"
//     ) {
//         return <PostsQualificationRenderer section={section} />;
//     }

//     if (sectionTitle === "Category-wise Vacancies") {
//         return <CategoryVacancyRenderer section={section} />;
//     }

//     switch (sectionType) {
//         case "table":
//             return <TableRenderer section={section} />;

//         case "bullet":
//             return <BulletRenderer section={section} />;

//         case "links":
//             return <LinksRenderer section={section} />;

//         case "paragraph":
//             return <ParagraphRenderer section={section} />;

//         case "steps":
//             return <StepsRenderer section={section} />;

//         case "faq":
//             return <FAQRenderer section={section} />;

//         case "salary_table":
//             return <SalaryRenderer section={section} />;

//         case "exam_pattern":
//             return <ExamPatternRenderer section={section} />;

//         default:
//             return (
//                 <KeyValueRenderer
//                     section={section}
//                     renderValue={renderValue}
//                 />
//             );
//     }
// }